

import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';



export interface ServiceParameter extends Parameter {
    SearchTerm: number;
    OrderBy: string;

}

export interface Service {
  dispPhyNameIPBillFlag?:string;
  zeroServiceFlag?:string;
    id?: string;
    name: string;
    code: string;
    type?:string;
    serviceCategoryId:string;
    serviceSubCategoryId?:string;  // add new field by RAJA
    serviceCategoryName?:string;
    serviceSubCategoryName?:string;
    price:number;
    isEditable:string;
  IsCultureTest?: string;
  isRedCrescent?: boolean;
    MappedAntibiotics?: any ;
    isHistopathologyTest?:string;
    isCytologyTest?:any;
    isActive:string;
    serviceType:string;
    tenantId?: string;
    branchId?: string;
    outsideLabId?:string;
    notesFlag?:string;
    notesSection?:string;
    PayerWardService?:PayerWardService[];
    parameters?: ServiceParameter[];
    links?: any;
    mappingAttribute?:string;
    gst?:number;
    snomedCode?:number;
    snomedDisplay?: string;
    loinc?: string;
    loincDisplay?: string;
    dateTimeInfo:boolean;
    employeeInfo:boolean;
    physicianInfo:boolean;
    restrictType?: string;
    restrictDays?: string;
    srvReqNo?: string;
    organizationId?:number;
    casesheetId?:string;
    casesheetParentId?:string;
    aditionalBarcodeFlag?:string;
    serAccountCode?:any;
    workOrderFlag?:boolean;
    outsideServiceFlag?:boolean;
    hsnCode?:String;    
    consultationServiceFlag?:any;
    hospitalShare?:number;
    refShare?:number;
    esicPanel?:number;
    jobCategoryId?:number;

    //Nphies
    ada?: string;
    achi?: string;
    cpt?: string;
    nphiesCode?: string;
    nphiesDisplay?: string;
    nphiesCategoryId?: number;
    nphiesUrl?: string;
    benefitCategoryId?: number;
    billingTypeId?: number;
    taxOtherCountryPatients?:string;
    tatDays?:string;
    tatHours?:string;
    tatMinutes?:string;
    isAllowDiscount?:boolean;
    IsShukhee?:boolean;
    hcpcsCode?:string;
    icdCode?:string;
    drgGroupCode?:string;
    nameLanguageValue?:string;
    sbscode?:string,
    sfdacode?:string,
    IsIDF?:string,
    GTINCode?:string,
    repeatEnabled?: boolean;
    repeatValue?: number;
    repeatUnit?: string;
    defaultPriority?: string;
    defaultDueIn?: number;
    billable?: boolean;
    quickPick?: boolean;
    nursingOrder?: boolean;
    recordFormType?: string;
    surgeryDuration?: number;
}
export interface PayerWardService{
  Price?: string;
  IsEditable:number;
  IsActive:string;
  tenantId?: string;
  branchId?: string;
  WardId?:string;
  PayerId?:string;
}

export interface BranchSrvc{
    id?: string;
    price:number;
    isEditable:string;
    isActive:string;
    tenantId?: string;
    branchId?: string;
    outsideLabId?:string;
    serviceId?:string;
    IsCultureTest?: string;
}
export interface TypeOptions {
    value: number;
    title: string;
  }
export abstract class ServiceData {
  //abstract fireRequest(data: Department, method: string): Observable<any>;
  abstract list(url: string): Observable<Service[]>;
  abstract searchList(url: string,data: any): Observable<any>;
  abstract create(url: string,data: Service): Observable<any>;
  abstract patch(url: string,data: Service): Observable<any>;
  abstract createServiceDetail(url: string,data: any): Observable<any>;
  abstract serviceDetailList(url: string): Observable<any[]>;
  abstract update(url: string,data: Service): Observable<any>;
  abstract updateBranchSrvc(url: string,data: BranchSrvc): Observable<any>;
  abstract updateBranchFields(url: string,data: any): Observable<any>;
  abstract delete(url: string): Observable<any>;
}
